import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShipmentProductQtyUomList } from '../common/CommonActions';
import { getProductUOMListTypesEffect } from '../shipment/ShipmentEffects';

const useShipmentProductQtyUomList = () => {
  const [list, setList] = useState(undefined);
  const { shipmentProductQtyUomList } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shipmentProductQtyUomList.success) {
      setList(shipmentProductQtyUomList.data);
    } else {
      getList();
    }
  }, [shipmentProductQtyUomList]);

  const getList = async () => {
    try {
      dispatch(setShipmentProductQtyUomList({ success: true, data: [] }));
      const { data } = await getProductUOMListTypesEffect();
      setList(data);
      dispatch(setShipmentProductQtyUomList({ success: true, data }));
    } catch (error) {
      setList([]);
    }
  };

  return list;
};

export default useShipmentProductQtyUomList;
